// ErrorFallback.tsx
import React from "react";
import "../css/pages/errorFallback.scss";

interface ErrorFallbackProps {
  error: Error;
  resetErrorBoundary: () => void;
}

const ErrorFallback: React.FC<ErrorFallbackProps> = ({
  error,
  resetErrorBoundary,
}) => {
  console.error("Error caught by withErrorBoundary:", error);
  return (
    <div className="error-fallback">
      <h2>خطایی رخ داده است</h2>
      <button onClick={resetErrorBoundary}>تلاش مجدد</button>
    </div>
  );
};

export default ErrorFallback;
